module.exports = __webpack_public_path__ + "img/attention-fill-big.326e276c.svg";